<template>
  <layout>
    <page-header :actions="actions" :header="$t('general.new_layout_zone_to_zone_price')" />
    <div class="content">
      <AdminTable v-if="currentDivision" ref="table" admin-table v-bind="tableProps">
        <template #zone_a.name="{ item }">
          <div :class="[item.zone_a ? '' : mutedClass, 'text-right']">
            {{ item.zone_a ? item.zone_a.name : textAny }}
          </div>
        </template>
        <template #is_both_directions="{ item }">
          <div :title="item.is_both_directions ? bothDirectionsLabel : ''" class="text-center">
            <i :class="[item.is_both_directions ? 'icon-transmission' : 'icon-arrow-right7','text-lg',]"></i>
          </div>
        </template>
        <template #zone_b.name="{ item }">
          <div :class="[item.zone_b ? '' : mutedClass]">{{ item.zone_b ? item.zone_b.name : textAny }}</div>
        </template>
        <template #vehicles="{ item }">
          <ul v-for="vehicle in item.vehicles" :key="vehicle.id" class="vehicle-list">
            <li>
              <template v-if="rateLabel(vehicle, item)">
                <span>{{vehicle.name}}:&nbsp;</span>
                <strong>
                  {{!item.pricing.z2z_by_request ? selectedCurrency.symbol : ''}}&nbsp;
                  {{rateLabel(vehicle, item)}}
                  {{item.pricing.z2z_by_request ? '%' : ''}}&nbsp;
                </strong>
              </template>
            </li>
          </ul>
        </template>
        <template #is_fixed="{ item }">
          {{ item.is_fixed ? $t('general.yes') : $t('general.no') }}
        </template>
        <template #priority="{ item }">
          <div>
            <span v-text="item.priority"></span>
          </div>
        </template>
        <template #pricing.by_request="{ item }">
          {{ item.pricing.z2z_by_request ? $t('general.yes') : $t('general.no') }}
        </template>
      </AdminTable>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import PriceZonesApi from './Api'

const base = 'route-pricing'

export default {
  name: 'ZoneToZonePricingIndex',

  components: {
    AdminTable,
  },

  data() {
    return {
      tableProps: {
        base: base,
        apiBuilder: () => {
          return new PriceZonesApi().setParameter(
            'division_id',
            this.currentDivision.id,
          )
        },
        sortBy: 'updated',
        sortDesc: true,
        perPage: 1000,
        columns: [
          {
            key: 'id',
            label: this.$t('general.id'),
          },
          {
            key: 'zone_a.name',
            label: this.$t('vehicles.attributes.pricing.zone_a.label'),
            thClass: 'text-right',
          },
          {
            key: 'is_both_directions',
            thClass: 'text-center',
            label: '',
          },
          {
            key: 'zone_b.name',
            label: this.$t('vehicles.attributes.pricing.zone_b.label'),
          },
          {
            key: 'vehicles',
            label: this.$t('vehicles.zone_to_zone_vehicles'),
            formatter: (value) => (value && value.length ? value.map(v => v.name).join(', ') : '—'),
          },
          {
            key: 'priority',
            label: this.$t('vehicles.attributes.pricing.priority.label'),
            sortable: true,
            defaultSortable: true,
          },
          {
            key: 'is_fixed',
            label: this.$t('vehicles.attributes.pricing.is_fixed.label'),
          },
          {
            key: 'pricing.by_request',
            label: this.$t('vehicles.attributes.pricing.by_request.label'),
          },
          // {
          //   key: 'pricing.one_way',
          //   label: this.$t('vehicles.attributes.pricing.one_way.label'),
          //   sortable: true,
          // },
          // {
          //   key: 'pricing.return',
          //   label: this.$t('vehicles.attributes.pricing.return.label'),
          //   sortable: true,
          // },
          // {
          //   key: 'pricing.minimum_price',
          //   label: this.$t('vehicles.attributes.pricing.minimum_price.label'),
          //   sortable: true,
          // },
        ],
        rowActions: item => {
          let actions = []

          if (this.$allows(`vehicles.update`) || this.$allows(`vehicles.view`)) {
            actions.push('edit')
          }
          if (this.$allows(`vehicles.delete`)) {
            actions.push('delete')
          }

          return actions
        },

        // define custom bulk actions
        bulkActions: () => {
          return []
        },
      },
    }
  },

  computed: {
    bothDirectionsLabel() {
      return this.$t('vehicles.attributes.pricing.both_directions.label')
    },
    textAny() {
      return `<${this.$t('general.any')}>`
    },
    mutedClass() {
      return {
        'text-muted': true,
        italic: true,
      }
    },
    // Page header actions
    actions() {
      if (this.$allows(`vehicles.create`)) {
        return [
          {
            id: 'create',
            text: this.$t('general.add_new'),
            icon: 'icon-plus-circle2',
            onClick: () => {
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              this.$router.push({
                name: `route-pricing.create`,
              })
            },
          },
        ]
      } else {
        return []
      }
    },
    selectedCurrency() {
      return this.$root.$account.currency ?? this.$settings.base_currency
    },
  },

  watch: {
    currentDivision() {
      this.$refs.table && this.$refs.table.reset()
    },
  },
  methods: {
    rateLabel(vehicle, item) {
      const pivot = vehicle.pivot?.pricing
      const v = pivot?.fixed_price && item.is_fixed ? pivot.fixed_price :
        item.pricing.z2z_by_request && this.hasExplicitZ2zPercent(pivot) ? pivot.by_request_percent :
      pivot?.minimum_price
      if (v == null || v === '') {
        return ''
      }
      return v
    },
    /** null / missing / '' = no auction for this vehicle; 0 = valid (no admin %). */
    hasExplicitZ2zPercent(pivotPricing) {
      if (!pivotPricing || typeof pivotPricing !== 'object') return false
      if (!Object.prototype.hasOwnProperty.call(pivotPricing, 'by_request_percent')) return false
      const x = pivotPricing.by_request_percent
      return x !== null && x !== undefined && x !== ''
    },
  }
}
</script>
<style scoped>
.vehicle-list {
  list-style: none;
  margin: 0;
  padding: 0;
  color: #787878;
}
.vehicle-list li {
  font-size: .775rem;
  display: flex;
  justify-content: space-between;
}
.vehicle-list li strong {
  color: #555;
}
</style>
